export default {
  title: 'Scorciatoie',
  links: {
    reservations: 'Prenotazioni',
    orders_portal: 'Accesso terminale',
    closed: 'Chiuso?',
    menu: 'Cambia menu',
    payouts: 'Report pagamenti',
    opening_hours: 'Orari di apertura',
  },
};
